<ada-container
	#MainContainer
	id="MainContainer"
	[horizontalSpacing]="'Medium'"
	[padding]="'[&#34;0px&#34;,&#34;1rem&#34;,&#34;0px&#34;,&#34;1rem&#34;]'"
	[verticalSpacing]="'Medium'"
>
	<ada-container
		#Container3
		id="Container3"
		[colCount]="0"
		[horizontalSpacing]="'Small'"
		[verticalAlignmentOfChildren]="'Middle'"
	>
		<ada-text
			#MonthByDateSetting
			id="MonthByDateSetting"
			[content]="'Month By Date Setting'"
			[fontWeight]="'Bold'"
		/>
		<ada-signpost
			#Signpost1
			id="Signpost1"
			[icon]="'faInfoCircleOutline'"
		>
			<ada-text
				#Text1
				id="Text1"
				[content]="'This Schedule will occur once every X months, on or after the specified date.'"
			/>
		</ada-signpost>
	</ada-container>
	<ada-container
		#Container4
		id="Container4"
		[colCount]="4"
		[horizontalSpacing]="'Medium'"
		[verticalSpacing]="'Medium'"
	>
		<ada-text
			#Text2
			id="Text2"
			[content]="'Recurring Interval in Months'"
		/>
		<ada-container
			#Container1
			id="Container1"
			[colCount]="2"
			[colSpan]="3"
		>
			<ada-input
				#RecurringIntervalInMonthsInput
				id="RecurringIntervalInMonthsInput"
				[debounce]="'500'"
				[isDisabled]="isDisabled"
				[max]="'127'"
				[min]="'1'"
				[placeholder]="'Number of months'"
				[showAsFullWidth]="true"
				[type]="'Number'"
				[value]="numberOfMonths"
				(valueChange)="setNumberOfMonths($event)"
			/>
		</ada-container>
		<ada-text
			#Text3
			id="Text3"
			[content]="'Day of Month'"
		/>
		<ada-container
			#Container2
			id="Container2"
			[colCount]="2"
			[colSpan]="3"
		>
			<ada-input
				#DayOfMonthInput
				id="DayOfMonthInput"
				[debounce]="'500'"
				[isDisabled]="isDisabled"
				[max]="'31'"
				[min]="'1'"
				[placeholder]="'Day of month'"
				[showAsFullWidth]="true"
				[type]="'Number'"
				[value]="dayOfMonth"
				(valueChange)="setDayOfMonth($event)"
			/>
		</ada-container>
	</ada-container>
</ada-container>
